<div class="lua-message-action-en-cours " >
    <lua-loader-circulaire [size]="loaderSize" [color]="loaderColor" [speed]="loaderSpeed"></lua-loader-circulaire>
    <div class="text-container">
      <h4 >{{ mainText }}</h4>
      <small >{{ subText }}</small>
    </div>
  </div>
